<template>
  <div>
    <div class="flex gap-[7px] justify-end">
      <div
        class="flex items-center max-w-[250px] rounded-[8px] gap-[5px] px-[8px]  border-[1px] border-[#E2E2E2]"
      >
        <span
          class="k-search-normal-1 font-bold  align-middle"
          style="font-size: 20px"
        />
        <BFormInput
          v-model="search"
          placeholder="Cari nama, email"
          class="border-0"
          @input="searchData"
        />
      </div>
      <BDropdown
        id="dropdown-1"
        no-caret
        toggle-class="toggle-custom"
        variant="primary"
        right
        size="sm"
      >
        <template #button-content>
          <img
            src="https://storage.googleapis.com/komerce/assets/komerce-icon/Putih/filter-search.svg"
            alt="filter"
          >
        </template>
        <div
          class="text-[#333333] my-1 font-semibold text-[14px] px-[10px] min-w-[250px]"
        >
          Filter
        </div>
        <hr>
        <div class="x-[10px] my-1">
          <BDropdown
            id="dropdown-2"
            variant="none"
            toggle-class="toggle-form"
            class="w-full text-left mr-[100px]"
            no-caret
            dropleft
            left
          >
            <template #button-content>
              <div class="text-left -ml-[10px] font-[400] text-[#333333]">
                Kartu Komcards
              </div>
            </template>
            <b-form-group>
              <b-form-radio-group
                id="btn-radios-1"
                v-model="state_radio"
                name="radios-stacked"
                stacked

                class="px-[6px] pt-[3px] w-full min-w-[165px]"
              >
                <b-form-radio
                  name="Punya Kartu"
                  value="true"
                  class="text-[#626262] font-[400] text-[14px]"
                >
                  Punya Kartu
                </b-form-radio>
                <b-form-radio
                  class="text-[#626262] font-[400] mt-1 text-[14px]"
                  name="Tidak Punya"
                  value="false"
                >
                  Tidak Punya
                </b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </BDropdown>
        </div>
        <hr>
        <div class="px-[10px] my-1 grid grid-cols-2 gap-[4px]">
          <BButton
            variant="outline-primary"
            @click="handleReset"
          >
            Reset
          </BButton>
          <BButton
            variant="primary"
            @click="handleSubmit"
          >
            Terapkan
          </BButton>
        </div>
      </BDropdown>
    </div>
    <BOverlay
      :show="loadingTable"
      spinner-variant="primary"
      variant="light"
      blur="0"
      opacity=".5"
      rounded="sm"
    >
      <div
        id="table"
        class="mt-1"
        style="height: calc(100vh - 250px); overflow-y: scroll;"
        @scroll="handleScroll"
      >
        <BTable
          :items="items"
          :fields="fields"
          show-empty
          empty-text="Tidak ada data"
          hover
          selectable
          select-mode="single"
        >
          <template #cell(partner_name)="data">
            <div class="flex items-center gap-4">
              <img
                v-if="data.item.badge_level"
                :src="data.item.badge_level"
                alt="verified"
                width="20"
              >
              <span
                v-if="data.item.name.length > 15"
                v-b-tooltip.hover
                :title="data.item.name"
                class="text-[14px] capitalize"
              >
                {{ data.item.name.slice(0, 10).toLowerCase() + '...' }}
              </span>
              <span
                v-else
                class="capitalize"
              >
                {{ data.item.name.toLowerCase() }}
              </span>
              <div
                v-if="!data.item.is_registered"
                class="flex items-center gap-4 border-[#FFF2E2] bg-[#FFF2E2] rounded-md px-[8px] py-[3px]"
                @click="registerToBank(data.item.user_id)"
              >
                <img
                  src="https://storage.googleapis.com/komerce/assets/komerce-icon/Orange/verify.svg"
                  alt="not-verified"
                  width="20"
                >
                <span>Registrasi Ulang</span>
              </div>
              <img
                v-else
                src="https://storage.googleapis.com/komerce/assets/icons/verified.svg"
                alt="verified"
              >
            </div>
            <br>
            <span class="text-[#828282] text-[14px]">
              {{ data.item.email }}</span>
          </template>
          <template #cell(telephone)="data">
            <span
              class="text-[14px] text-[#333333] text-left  flex justify-start w-100"
            >
              {{ data.item.phone }}</span>
          </template>

          <template #cell(used_card_count)="data">
            <div
              class="text-[14px] text-[#333333] text-left flex justify-start items-center w-100 gap-[4px]"
            >
              <span class="text-[#34A770]">{{ data.item.used_card_count }}</span>
              <span>/</span>
              <span
                v-if="data.item.control_account.type_control === 'komcard_score'"
                class="text-[#828282]"
              >{{
                data.item.quota_card_count
              }}</span>
              <input
                v-else
                v-model="data.item.quota_card_count"
                type="number"
                min="1"
                max="1000"
                class="w-[60px] h-[32px] border border-[#E0E0E0] rounded-[8px] text-center text-[#333333] text-[14px] outline-none m-0"
                style="appearance: textfield;"
                @keydown="preventInvalidNumber"
                @focus="originalQuota = data.item.quota_card_count"
                @blur="updateQuota(data.item)"
                @keyup.enter="$event.target.blur()"
              >
            </div>
          </template>
          <template #cell(account_control)="{ item }">
            <span
              class="text-[14px] flex justify-center w-fit rounded-full px-2 py-[3px]"
              :class="getAccountControlClass(item.control_account)"
            >
              {{ getAccountControlText(item.control_account) }}
            </span>
          </template>
          <template #cell(total_spending)="data">
            <span
              class="text-[14px] text-[#333333] text-left flex justify-start w-100"
            >
              {{ IDR(data.item.total_spending,2,2) }}</span>
          </template>
          <template #cell(last_transaction)="data">
            <span
              class="text-[14px] text-[#333333] text-left  flex justify-start w-100"
            >
              {{
                data.item.last_transaction
                  ? DAY_MONTH_YEAR(data.item.last_transaction)
                  : '-'
              }}</span>
          </template>
          <template #cell(more)="data">
            <span class="flex justify-center">
              <BDropdown
                variant="none"
                no-caret
                offset="-100"
                left
                size="sm"
              >
                <template #button-content>
                  <button class="bg-transparent">
                    <img
                      src="https://storage.googleapis.com/komerce/assets/komerce-icon/Hitam/more.svg"
                      alt="more-icon"
                    >
                  </button>
                </template>
                <div class="flex flex-col gap-[5px] p-[5px] w-[200px]">
                  <div
                    class="flex gap-[3px] items-center px-[4px] hover:bg-[#f8f8f8] text-[#626262] text-[14px]"
                    @click="$router.push('/komcards-data-partner/' + data.item.user_id)"
                  >
                    <img
                      src="https://storage.googleapis.com/komerce/assets/komerce-icon/Hitam/eye.svg"
                      alt="eye"
                    >
                    <div>Detail Partner</div>
                  </div>
                  <a
                    class="flex gap-[3px] items-center px-[4px] hover:bg-[#f8f8f8] text-[#626262] text-[14px]"
                    :href="'/komcards-data-partner/insufficient-balance/' + data.item.user_id"
                    target="_blank"
                  >
                    <img
                      src="https://storage.googleapis.com/komerce/assets/komerce-icon/Hitam/receipt-1.svg"
                      alt="eye"
                    >
                    <div>Insufficent Balance</div>
                  </a>
                  <a
                    v-if="data.item.control_account.type_control === 'komcard_score'"
                    class="flex gap-[3px] items-center px-[4px] hover:bg-[#f8f8f8] text-[#626262] text-[14px]"
                    @click="addQuotaCard(data.item)"
                  >
                    <img
                      src="https://storage.googleapis.com/komerce/assets/komerce-icon/Hitam/card-add.svg"
                      alt="add"
                    >
                    <div>Add Quota Card</div>
                  </a>
                  <a
                    class="flex gap-[3px] items-center px-[4px] hover:bg-[#f8f8f8] text-[#626262] text-[14px]"
                    @click="changeAccountControl(data.item)"
                  >
                    <img
                      src="https://storage.googleapis.com/komerce/assets/icons/switch.svg"
                      alt="switch"
                      width="20"
                      height="20"
                    >
                    <div>{{ data.item.control_account.type_control === 'manual' ? 'Ubah ke KS' : 'Input Manual' }}</div>
                  </a>
                  <a
                    class="flex gap-[3px] items-center px-[4px] hover:bg-[#f8f8f8] text-[#626262] text-[14px]"
                    @click="onReview(data.item.user_id)"
                  >
                    <img
                      src="https://storage.googleapis.com/komerce/assets/icons/stop-outlined.svg"
                      alt="Hold"
                      width="20"
                      height="20"
                    >
                    <div class="text-primary">Suspend</div>
                  </a>
                </div>
              </BDropdown>
            </span>
          </template>
        </BTable>
      </div>
    </BOverlay>
    <ModalAdd
      :data="dataPartner"
      :data-quota="dataAddQuota"
      :data-level="dataLevelUser"
    />

    <ModalReview
      :id="userId"
      :type="'Suspend User'"
      @onRefetch="onModalRefetch"
    />

    <ModalAccountControl
      :data-item="selectedAccountControlItem"
      :is-score="isAccountControlScore"
      @confirm="handleConfirmAccountControl"
    />
  </div>
</template>

<script>
import { IDR } from '@/libs/currency'
import { DAY_MONTH_YEAR } from '@/libs/filterDate'
import { newAxiosIns } from '@/libs/axios'
import { columnConfig } from './config'
import ModalAdd from './ModalAddQuotaCard.vue'
import ModalReview from './ModalReview.vue'
import ModalAccountControl from './ModalAccountControl.vue'

export default {
  components: {
    ModalAdd,
    ModalReview,
    ModalAccountControl,
  },
  data() {
    return {
      originalQuota: null,
      selectedAccountControlItem: null,
      isAccountControlScore: true,
      items: null,
      loadingTable: false,
      fields: columnConfig,
      IDR,
      DAY_MONTH_YEAR,
      lastData: false,
      offset: 0,
      limit: 25,
      search: null,
      has_card: true,
      state_radio: true,
      dataPartner: {},
      dataAddQuota: {},
      dataLevelUser: [],
      userId: null,
    }
  },
  mounted() {
    this.getList()

    // to handle nested dropdown click anomaly
    this.$root.$on('bv::dropdown::show', bvEvent => {
      if (bvEvent.componentId === 'dropdown-2') {
        this.isDropdown2Visible = true
        this.state_radio = this.has_card
      }
    })
    this.$root.$on('bv::dropdown::hide', bvEvent => {
      if (bvEvent.componentId === 'dropdown-2') {
        this.isDropdown2Visible = false
      }
      if (this.isDropdown2Visible) {
        bvEvent.preventDefault()
      }
    })
  },
  methods: {
    onModalRefetch() {
      this.search = null
      this.offset = 0
      this.limit = 25
      this.has_card = true
      this.getList()
    },
    handleScroll() {
      const table = document.getElementById('table')
      if (
        table.scrollTop >= table.scrollHeight - table.offsetHeight - 5
        && !this.loading
        && !this.lastData
      ) {
        this.getNextData()
      }
    },
    handleReset() {
      this.offset = 0
      this.has_card = true
      this.getList()
    },
    handleSubmit() {
      this.offset = 0
      this.has_card = this.state_radio
      this.getList()
    },
    searchData: _.debounce(function search(text) {
      this.offset = 0
      this.getList()
    }, 1000),
    async getList() {
      this.loadingTable = true

      const params = {
        search: this.search,
        has_card: this.has_card,
        offset: this.offset,
        limit: this.limit,
      }

      const url = '/auth/api/v1/komcard/partners'

      await newAxiosIns
        .get(url, { params })
        .then(res => {
          const { data } = res.data
          this.loadingTable = false
          this.offset = data.length
          this.items = data
          if (data.length < this.limit) {
            this.lastData = true
          } else {
            this.lastData = false
          }
        })
        .catch(() => {
          this.$toast_error({ message: 'Gagal load data' })
          this.loadingTable = false
        })
    },
    getNextData() {
      if (!this.lastData) {
        this.loadingTable = true
        const params = {
          search: this.search,
          has_card: this.has_card,
          offset: this.offset,
          limit: this.limit,
        }

        const url = '/auth/api/v1/komcard/partners'

        newAxiosIns
          .get(url, { params })
          .then(res => {
            const { data } = res.data
            this.items.push(...data)
            this.offset += data.length
            this.loadingTable = false
            if (data.length < this.limit) {
              this.lastData = true
            }
          })
          .catch(() => {
            this.loadingTable = false
            this.$toast_error({ message: 'Gagal load data' })
          })
      }
    },
    getKsBgClass(score) {
      if (score === null || score === undefined || score === '-') return 'bg-[#F5F5F5] text-[#333333]'
      const numScore = parseInt(score, 10)
      if (Number.isNaN(numScore)) return 'bg-[#F5F5F5] text-[#333333]'
      if (numScore <= 40) return 'bg-[#FDE8E8] text-[#333333]'
      if (numScore <= 60) return 'bg-[#FFF0A8] text-[#333333]'
      return 'bg-[#DCF3EB] text-[#333333]'
    },
    getAccountControlClass(control) {
      if (control?.type_control === 'komcard_score') {
        return this.getKsBgClass(control.komcard_score)
      }
      return 'bg-[#F5F5F5] text-[#333333]'
    },
    getAccountControlText(control) {
      if (control?.type_control === 'komcard_score') {
        return `KS : ${control.komcard_score || '-'}`
      }
      return 'Input Manual'
    },
    addQuotaCard(e) {
      this.loadingTable = true
      this.dataPartner = e
      const url = `komcards/api/v1/user/${e.user_id}/quota/info`
      newAxiosIns
        .get(url)
        .then(res => {
          this.loadingTable = false
          const { data } = res.data
          this.dataAddQuota = data
        })
        .catch(() => {
          this.loadingTable = false
          this.$toast_error({ message: 'Gagal load data' })
        })
      this.getLevelUser(e)
    },
    getLevelUser(e) {
      this.loadingTable = true
      const url = `/auth/api/v1/user/levels/${e.user_id}`
      newAxiosIns
        .get(url)
        .then(res => {
          this.loadingTable = false
          const { data } = res.data
          this.dataLevelUser = data
        })
        .catch(() => {
          this.loadingTable = false
          this.$toast_error({ message: 'Gagal load data' })
        })
      this.$bvModal.show('modal-add-quota')
    },
    async registerToBank(userId) {
      this.$swal({
        title: '<span class="text-xl">Re-registrasi User Komcards</span>',
        text: 'Yakin ingin mendaftarkan kembali user ini ke monit?',
        showCancelButton: true,
        confirmButtonText: 'Yakin',
        cancelButtonText: 'Batal',
        imageUrl: 'https://storage.googleapis.com/komerce/assets/icons/warning.svg',
        reverseButtons: true,
        showLoaderOnConfirm: true,
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-primary mr-1',
        },
        buttonsStyling: false,
        allowOutsideClick: () => !this.$swal.isLoading(),
        preConfirm: async () => {
          const url = `/auth/api/v1/komcard/${userId}/register-bank`
          try {
            await newAxiosIns.post(url)
            this.$toast_success({ message: 'Berhasil mendaftarkan user' })
            const item = this.items.find(i => i.user_id === userId)
            if (item) {
              item.register_status = true
            }
          } catch {
            this.$toast_error({ message: 'Gagal mendaftarkan user. Hubungi tim teknis' })
          }
        },
      })
    },
    onReview(id) {
      this.userId = id
      this.$bvModal.show('modal-review')
    },
    changeAccountControl(e) {
      this.selectedAccountControlItem = e
      this.isAccountControlScore = e.control_account.type_control === 'komcard_score'
      this.$bvModal.show('modal-account-control')
    },
    updateQuota(item) {
      if (!item.quota_card_count) {
        this.$set(item, 'quota_card_count', this.originalQuota)
        return
      }

      const newQuota = parseInt(item.quota_card_count, 10)
      if (newQuota < 1) {
        this.$toast_error({ message: 'Minimal kuota kartu adalah 1' })
        this.$set(item, 'quota_card_count', this.originalQuota)
        return
      }
      if (newQuota > 1000) {
        this.$toast_error({ message: 'Maksimal kuota kartu adalah 1000' })
        this.$set(item, 'quota_card_count', this.originalQuota)
        return
      }

      if (parseInt(this.originalQuota, 10) === newQuota) return
      this.originalQuota = item.quota_card_count
      this.loadingTable = true
      const url = `komcards/api/v1/user/${item.user_id}/quota`
      newAxiosIns
        .post(url, { new_quota: newQuota })
        .then(() => {
          this.loadingTable = false
          this.$toast_success({ message: 'Quota kartu berhasil diperbaharui' })
        })
        .catch(() => {
          this.loadingTable = false
          this.$set(item, 'quota_card_count', this.originalQuota)
          this.$toast_error({ message: 'Gagal memperbarui quota' })
        })
    },
    preventInvalidNumber(e) {
      if (['e', 'E', '+', '-', '.', ','].includes(e.key)) {
        e.preventDefault()
      }
    },
    handleConfirmAccountControl(payload) {
      const item = this.items.find(i => i.user_id === payload.user_id)
      if (item) {
        item.account_control = payload.isScore
        if (!item.account_control && (!item.quota_card_count || item.quota_card_count === 0)) {
          item.quota_card_count = 20
        }
      }
      const url = 'komcards/api/v1/user/control-account'
      newAxiosIns
        .put(url, {
          user_id: parseInt(payload.user_id, 10),
          type_control: payload.isScore ? 'manual' : 'komcard_score',
        })
        .then(res => {
          this.$bvModal.hide('modal-account-control')
          this.$toast_success({ message: `Berhasil mengubah Kontrol Akun menjadi ${this.isAccountControlScore ? 'Input Manual' : 'Komcards Score'} akun` })
          newAxiosIns
            .get('/auth/api/v1/komcard/partners', {
              params: {
                search: this.search,
                has_card: this.has_card,
                offset: 0,
                limit: this.offset || this.limit,
              },
            })
            .then(fetchRes => {
              if (fetchRes.data?.data) {
                this.items = fetchRes.data.data
              }
            })
        })
        .catch(() => {
          this.$toast_error({ message: 'Gagal mengubah Kontrol Akun' })
        })
    },
  },
}
</script>

<style scoped>
.dropdown-toggle:hover {
  background-color: white !important;
}
</style>
